import React, { useState, useEffect } from "react";
import { FaPhone, FaWhatsapp } from "react-icons/fa";
import "./styles.css";

const OldPatientComponent = ({ setCurrentQuestion }) => {
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  const phoneNumber = "+34 961 561 111";
  const mobilNumber = "+34 634 517 000";
  const urlWhatsapp =
    "https://api.whatsapp.com/send/?phone=34634517000&text&type=phone_number&app_absent=0";

  const phoneClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const whatsappClick = () => {
    window.open(urlWhatsapp);
  };

  useEffect(() => {
    const resize = () => {
      setShowPhoneNumber(window.innerWidth > 768);
    };

    resize();
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className="containerOldPatient">
      <h1 className="questionAppointmentOldPatient">
        Si ya es paciente, solicite la cita a través del teléfono o WhatsApp
      </h1>
      <div className="iconContainer">
        <FaPhone className="phoneIcon" onClick={phoneClick} />
        <div className="iconColumn" onClick={whatsappClick}>
          <FaWhatsapp className="whatsappIcon" />
        </div>
      </div>
      {showPhoneNumber && (
        <div>
          <pre>
            <h1 className="numberModalOldPatient">{mobilNumber}</h1>
            <h1 className="numberModalOldPatient">{phoneNumber}</h1>
          </pre>
        </div>
      )}
      <button className="btnAtras" onClick={() => setCurrentQuestion(1)}>
        Atrás
      </button>
    </div>
  );
};

export default OldPatientComponent;
